import { HubSortListOrderEntry } from '../../hooks/useFetchHubSortList';
import { OrderScannerTablePrint } from '../OrderScannerTablePrint/OrderScannerTablePrint';
import { OrderScannerTable } from '../OrderScannerTable/OrderScannerTable';
import React from 'react';
import { CellMeasurerCache, List } from 'react-virtualized';

interface ShowOrderScannerTableProps {
  bundleOrders: HubSortListOrderEntry[];
  updateHubSortListEntries: (bundlesId: string[]) => Promise<void>;
  bundleId: string;
  onlyRemaining?: boolean;
  cache?: CellMeasurerCache;
  listRef?: List;
  virtualizationIndex?: number;
}

const ShowOrderScannerTable = ({
  bundleOrders,
  updateHubSortListEntries,
  bundleId,
  onlyRemaining,
  cache,
  listRef,
  virtualizationIndex,
}: ShowOrderScannerTableProps): JSX.Element => {
  return (
    <>
      <div className="u-print-only">
        <OrderScannerTablePrint orders={bundleOrders} />
      </div>
      <div className="u-screen-only">
        <OrderScannerTable
          orders={bundleOrders}
          updateHubSortListEntries={updateHubSortListEntries}
          bundleId={bundleId}
          onlyRemaining={onlyRemaining}
          cache={cache}
          listRef={listRef}
          virtualizationIndex={virtualizationIndex}
        />
      </div>
    </>
  );
};

export { ShowOrderScannerTable };
